import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'app-discount-tracker',
	templateUrl: './discount-tracker.component.html',
	styleUrls: ['./discount-tracker.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DiscountTrackerComponent implements OnInit {
	@Input() promoCode;

	public progressBar;

	public valueContainer;

	public progressValue = 0;

	public currentLimit;

	public speed = 6;

	public total;

	public available;

	public fraction;

	constructor() { }

	ngOnInit(): void {
		setTimeout(() => {
			this.currentLimit = this.promoCode.currentLimit;
			this.total = this.promoCode.discountLimit;
			this.fraction = this.total / 4;
			this.available = this.total - this.currentLimit;
			this.progressBar = <HTMLElement>document.querySelector('.circular-progress');
			this.valueContainer = <HTMLElement>document.querySelector('.value-container');
			const progress = setInterval(() => {
				if (this.progressValue === Math.round(this.currentLimit)) {
					clearInterval(progress);
				}
				this.progressValue += 1;
				this.valueContainer.textContent = `$${this.available.toFixed(2)}`;
				this.progressBar.style.background = `conic-gradient(
            #34BB9F ${(this.progressValue / this.total) * 360}deg,
            #E5F4F1 ${(this.progressValue / this.total) * 360}deg
        )`;
				if (this.progressValue === Math.round(this.currentLimit)) {
					clearInterval(progress);
				}
			}, this.speed);
		}, 200);
	}
}
